"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addQueryParamsToUrl = void 0;
function addQueryParamsToUrl(url, queryParams) {
    if (!url || url.length === 0) {
        return "";
    }
    if (!queryParams || queryParams.length === 0) {
        return url;
    }
    let newUrl = new URL(url);
    queryParams.forEach((queryParam) => {
        if (!newUrl.searchParams.has(queryParam.key)) {
            newUrl.searchParams.set(queryParam.key, String(queryParam.value));
        }
    });
    return newUrl.toString();
}
exports.addQueryParamsToUrl = addQueryParamsToUrl;
